import DownAltSvg from 'assets/svg/DownAlt';
import UpAltSvg from 'assets/svg/UpAlt';
import { Select } from 'antd';
import styled from '@emotion/styled';
import _ from 'lodash';
import PromoMetrics from './PromoMetrics';
import SpendDetails from './SpendDetails';

export const PromoSelect = styled(Select)`
    .ant-select-arrow-loading {
        color: blue !important;
        font-size: 16px;
    }
    .ant-select-selector {
        border-radius: 6px !important;
        border: none !important;
    }
    &.ant-select-multiple .ant-select-selection-item-remove {
        position: relative;
        top: -2px;
    }
`;

interface MetricsSectionProps {
    metricsExists: boolean;
    spendExists: boolean;
    showMetrics: boolean;
    setShowMetrics: Function;
    showSpendDetails: boolean;
    setShowSpendDetails: Function;
}

const promoSyncId = 'promo_details_sync_scroll';

const MetricsSection: React.FC<MetricsSectionProps> = ({
    metricsExists,
    spendExists,
    showMetrics,
    setShowMetrics,
    showSpendDetails,
    setShowSpendDetails,
}) => {
    return (
        <>
            {/* SCROLLABLE METRICS   */}
            <div className="min-h-0 flex-1 overflow-y-auto  ">
                {/* PROMO METRICS  */}
                {metricsExists && (
                    <div className="relative  my-4 ">
                        <button
                            className={`bg-violetAlt w-[140px] p-1 px-2.5 rounded-t-lg flex justify-between items-center text-white cursor-pointer ${
                                showMetrics ? '' : 'rounded-b-lg'
                            } `}
                            onClick={() => {
                                setShowMetrics(!showMetrics);
                            }}
                        >
                            <span> Metrics</span>
                            {showMetrics ? <UpAltSvg stroke="white" /> : <DownAltSvg stroke="white" />}
                        </button>

                        {showMetrics && <PromoMetrics promoSyncId={promoSyncId} />}
                    </div>
                )}

                {/* SPEND DETAILS */}
                {spendExists && (
                    <div className="relative  my-4 ">
                        <button
                            className={`bg-violetAlt w-[140px] p-1 px-2.5 rounded-t-lg flex justify-between items-center text-white cursor-pointer ${
                                showSpendDetails ? '' : 'rounded-b-lg'
                            } `}
                            onClick={() => {
                                setShowSpendDetails(!showSpendDetails);
                            }}
                        >
                            <span> Spend Details</span>
                            {showSpendDetails ? <UpAltSvg stroke="white" /> : <DownAltSvg stroke="white" />}
                        </button>

                        {showSpendDetails && <SpendDetails promoSyncId={promoSyncId} />}
                    </div>
                )}
            </div>
        </>
    );
};

export default MetricsSection;
